import Portal from "Utilities/PortalMaker";

import SignupAddressCard from "./SignupAddressCard";
import useAddressHolders from "./useAddressHolders";

// Extended-field type ID for an Address field (matches the legacy
// `extendedFieldTypes` map in extendedFields.js and IIGAddressPortal).
const ADDRESS_FIELD_TYPE_ID = 4;

/**
 * Bridges the Simple Signup / completeMyProfile page
 * (`/network/{id}/completeMyProfile`) to the React Address field.
 *
 * The legacy `signupExtendedFields.js` renders every extended field into
 * `.extended_fields_holder`, but for Address fields it stands the legacy
 * big-flag widget down and drops a `.signup_address_react_holder` (tagged with
 * the field's networkFieldID) in its place. This portal reads the PHP bootstrap
 * on `window.data.extendedFields`, matches each holder to its field entry, and
 * mounts a React card into it. A network may configure several Address fields,
 * hence one card per holder.
 */
export default function SignupAddressPortal() {
  const holders = useAddressHolders();
  const extendedFields = window.data?.extendedFields;

  if (!extendedFields) return null;

  return holders.map(({ node, networkFieldID }) => {
    const efInfo = extendedFields.find(
      (field) =>
        field.networkFieldID === networkFieldID &&
        field.fieldTypeID === ADDRESS_FIELD_TYPE_ID
    );
    if (!efInfo) return null;

    const countryVisible = Boolean(
      efInfo.configuration?.subfields?.country?.isVisible
    );

    return (
      <Portal key={networkFieldID} to={node}>
        <SignupAddressCard
          efInfo={efInfo}
          networkFieldID={networkFieldID}
          initialValue={efInfo.response}
          countryVisible={countryVisible}
        />
      </Portal>
    );
  });
}
